import { render, staticRenderFns } from "./purchaseDetails.vue?vue&type=template&id=2fdae6ee&"
import script from "./purchaseDetails.vue?vue&type=script&lang=js&"
export * from "./purchaseDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports